import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import styled from 'styled-components';
import { TaskId } from 'api/models';
import { Button } from 'components/atoms/button';
import { Loading } from 'components/atoms/loading';
import { TaskDescription } from 'components/molecules/tasks/details/description';
import { ImageHandler } from 'components/organisms/task-pane/task-detail/description';
import {
  UpdateTaskActionPayloadOptions,
  updateTaskSagaAction,
} from 'data/tasks/actions';
import { useTaskDetailQuery } from 'queries/task';

const BlueGhostButton = styled(Button).attrs({ type: 'text' })`
  color: var(--blue-60);
`;

const Footer = styled.div`
  /* position: fixed;
  bottom: 20px;
  z-index: 10;
  background-color: white; */
`;

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const RespTaskDesc: React.FC = () => {
  const { taskId: _taskId, projectId: _projectId } =
    useParams<{ taskId: string; projectId: string }>();
  const dispatch = useDispatch();

  const taskId = Number(_taskId);
  const projectId = Number(_projectId);

  const { data } = useTaskDetailQuery(TaskId(projectId, taskId));

  const updateTask = (payload, options?: UpdateTaskActionPayloadOptions) => {
    dispatch(
      updateTaskSagaAction({ projectId, taskId, data: payload, options }),
    );
  };

  const updateTaskDescription = (taskDescription: string) => {
    updateTask({
      taskDescription,
    });
  };

  if (data === undefined) {
    return <Loading />;
  }

  return (
    <StyledContainer>
      <ImageHandler canOpenImage width="100%">
        <TaskDescription.Editor
          taskDescription={data.taskDescription}
          updateTask={updateTaskDescription}
          projectId={projectId}
        />
      </ImageHandler>
      <Footer>
        <BlueGhostButton>
          <FormattedMessage id="save" />
        </BlueGhostButton>
      </Footer>
    </StyledContainer>
  );
};
